module.exports = __webpack_public_path__ + "static/media/rawpixel-comm.f369835a.jpg";